export const addMetadataToMap = (
  mapKey: symbol,
  propertyKey: string,
  value: any,
  target: object
) => {
  const map = Reflect.getMetadata(mapKey, target) || {};
  map[propertyKey] = value;
  Reflect.defineMetadata(mapKey, map, target);
};

export const parseLocationName = (location_name: string): ParsedLocation => {
  location_name = location_name ? location_name : '';
  let parts = location_name.split(',').reverse();
  const parsed: ParsedLocation = {};
  for (let part of parts) {
    let index = parts.indexOf(part);
    part = part.replace(/^\s+|\s+$/g, '');

    if (part === 'USA' || part === 'United States') {
      parsed.country = part;
    }
    if (index == 1) {
      parsed.state = part;
    }
    if (index == 2) {
      parsed.city = part;
    }
    if (index == 3) {
      parsed.street = part;
    }
    if (index == 4) {
      parsed.nickname = part;
    }
    if (parts.length === 1) {
      parsed.nickname = part;
    }
  }
  return parsed;
};

export interface ParsedLocation {
  country?: string;
  state?: string;
  city?: string;
  street?: string;
  nickname?: string;
}



// WEBPACK FOOTER //
// ./src/models/base/util.ts